import { Record } from "immutable";
import content from "./content";
import { STATIC_PATH, vmakerTeam } from "./config";
import vmTheme from "./theme/index";

export { vmakerTeam };

const {
  MOVE_TO,
  RENAME,
  DELETE,
  NO_TRANSITION,
  FADE,
  SIDE_LEFT,
  SIDE_TOP,
  SIDE_BOTTOM,
  SIDE_RIGHT,
  LANDSCAPE,
  POETRAIT,
  SQUARE,
} = content;

export const PORTAL_ID = "modal-portal";

export const MOBILE_THRESHOLD = 768;

export const SIDEBAR_WIDTH = 65;

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PANEL = {
  NONE: "NONE",
  VIRALSTYLE: "VIRALSTYLE",
  PROPERTIES: "PROPERTIES",
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  MUSIC: "MUSIC",
  UPLOAD: "UPLOAD",
  TRANSITIONS: "TRANSITIONS",
  FAVORITES: "FAVORITES",
  GIPHY: "GIPHY",
  VERSION_HISTORY: "VERSION_HISTORY",
  SUBTITLE: "SUBTITLE",
  UNSPLASH: "UNSPLASH",
  PEXELS: "PEXELS",
  PEXELS_VIDEO: "PEXELS_VIDEO",
  PIXABAY: "PIXABAY",
  PIXABAY_VIDEO: "PIXABAY_VIDEO",
  MORE: "MORE",
  AVATAR: "AVATAR",
  RECORDING: "RECORDING",
  EXPORT: "EXPORT",
};

export const PanelRecord = Record({
  selectedPanel: PANEL.NONE,
  isExpand: false,
});

export const PropertyWindowRecord = Record({
  component: "",
  subWindow: "",
  isTextColor: false,
  type: "",
  isOpened: false,
});

export const PANEL_ITEMS = (theme) => {
  return [
    {
      name: PANEL.AVATAR,
      src: `${STATIC_PATH}${vmTheme[theme].icons.avatar}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.avatarSelected}`,
      content: content.AI_AVATARS,
    },
    {
      name: PANEL.VIDEO,
      src: `${STATIC_PATH}${vmTheme[theme].icons.videoIconSelected}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.videoIcon}`,
      content: content.VIDEO,
    },
    {
      name: PANEL.IMAGE,
      src: `${STATIC_PATH}${vmTheme[theme].icons.imageIcon}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.imageIconSelected}`,
      content: content.IMAGE,
    },
    {
      name: PANEL.MUSIC,
      src: `${STATIC_PATH}${vmTheme[theme].icons.musicIconSelected}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.musicIcon}`,
      content: content.MUSIC,
    },
    {
      name: PANEL.SUBTITLE,
      src: `${STATIC_PATH}${vmTheme[theme].icons.subtitleHoverIcon}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.subtitleIcon}`,
      content: content.SUBTITLE,
    },
    {
      name: PANEL.PROPERTIES,
      src: `${STATIC_PATH}${vmTheme[theme].icons.property}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.propertySelected}`,
      content: content.ELEMENTS,
    },
    {
      name: PANEL.TEXT,
      src: `${STATIC_PATH}${vmTheme[theme].icons.textIconSelected}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.textIcon}`,
      content: content.TEXT,
    },
    {
      name: PANEL.UPLOAD,
      src: `${STATIC_PATH}${vmTheme[theme].icons.uploadIconSelected}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.uploadIcon}`,
      content: content.UPLOAD,
    },
    {
      name: PANEL.TRANSITIONS,
      src: `${STATIC_PATH}transitions-panel-icon.svg`,
      selectedSrc: `${STATIC_PATH}transitions-panel-selected.svg`,
      content: content.TRANSITIONS,
    },
    {
      name: PANEL.MORE,
      src: `${STATIC_PATH}${vmTheme[theme].icons.moreIcon}`,
      selectedSrc: `${STATIC_PATH}${vmTheme[theme].icons.moreActiveIcon}`,
      content: content.MORE,
    },
  ];
};

export const PROPERTIES_FILTER = [
  {
    category: "Shapes (With Text)",
    source: [
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d121c5aea1084db48125d6924d6f459a-shape-0001.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/9cafd6d1c2e4401f80aa357c1578a8ca-shape-0002.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d75f1cdd5751457f9c73abb2fb151bce-shape-0003.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/29eae6290a834014b648b0743638a29e-shape-0030.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/e3b66477d06f46e58cc7f56800ace373-shape-0018.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d121c5aea1084db48125d6924d6f459a-shape-0001.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/9cafd6d1c2e4401f80aa357c1578a8ca-shape-0002.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d75f1cdd5751457f9c73abb2fb151bce-shape-0003.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/29eae6290a834014b648b0743638a29e-shape-0030.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/e3b66477d06f46e58cc7f56800ace373-shape-0018.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d121c5aea1084db48125d6924d6f459a-shape-0001.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/9cafd6d1c2e4401f80aa357c1578a8ca-shape-0002.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d75f1cdd5751457f9c73abb2fb151bce-shape-0003.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/1bb3463aa83d4f3899de4dc7eace3694-shape-0009.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/10b95b3a7cef401daadd65d9695c0a13-shape-0011.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/4ce2b2ee54fb45fdb0337c7d6cc10a86-shape-0013.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d121c5aea1084db48125d6924d6f459a-shape-0001.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/9cafd6d1c2e4401f80aa357c1578a8ca-shape-0002.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/d75f1cdd5751457f9c73abb2fb151bce-shape-0003.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/29eae6290a834014b648b0743638a29e-shape-0030.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/e3b66477d06f46e58cc7f56800ace373-shape-0018.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/1bb3463aa83d4f3899de4dc7eace3694-shape-0009.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/10b95b3a7cef401daadd65d9695c0a13-shape-0011.png",
      },
      {
        src: "https://library.animaker.com/animaker/shapes/thumbnails/4ce2b2ee54fb45fdb0337c7d6cc10a86-shape-0013.png",
      },
    ],
  },
];

export const VIDEO_FILTERS = [
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
  {
    src: "https://static.animaker.com/animapp-static/images/filter-icons/original.png",
    title: "Original",
  },
];

export const TRANSITION_PANEL_ITEMS = [
  {
    src: `${STATIC_PATH}no-transition.svg`,
    title: NO_TRANSITION,
  },
  {
    src: `${STATIC_PATH}fade.svg`,
    title: FADE,
  },
  {
    src: `${STATIC_PATH}side-left.svg`,
    title: SIDE_LEFT,
  },
  {
    src: `${STATIC_PATH}side-top.svg`,
    title: SIDE_TOP,
  },
  {
    src: `${STATIC_PATH}side-bottom.svg`,
    title: SIDE_BOTTOM,
  },
  {
    src: `${STATIC_PATH}side-right.svg`,
    title: SIDE_RIGHT,
  },
];

export const MENU_OPTIONS = [MOVE_TO, RENAME, DELETE];

export const CONSTANTS = {
  LIBRARY_TYPE: {
    TEXT: "TEXT",
    PROPERTY: {
      MASPROP: "MASPROP",
      PROP_SHAPE_FRAME: "PROP,SHAPE,FRAME",
    },
    VIDEO: {
      STOCKVID: "STOCKVID",
      MASSTOCKVID: "MASSTOCKVID",
      PEXELS_VIDEO: "PEXELS_VIDEO",
      PIXABAY_VIDEO: "PIXABAY_VIDEO"
    },
    IMAGE: {
      STOCKIMG: "STOCKIMG",
      MASSTOCKIMG: "MASSTOCKIMG",
      UNSPLASH: "UNSPLASH",
      PEXELS: "PEXELS",
      PIXABAY: "PIXABAY"
    },
    MUSIC: {
      MASBGM: "MASBGM",
      MASSFX: "MASSFX",
      SFX: "SFX",
      BGM: "BGM",
    },
    GIPHY: {
      STOCKGIPHY: "GIPHY",
      MASGIPHY: "MASGIPHY",
    },
    VIRALSTYLE: {
      STOCKGIPHY: "VIRALSTYLE",
      MASGIPHY: "MASVIRALSTYLE",
    },
  },
};

export const FILE_FORMATS = [
  { label: "mp4", id: "mp4", value: "mp4" },
  { label: "avi", id: "avi", value: "avi" },
  { label: "mkv", id: "mkv", value: "mkv" },
  { label: "flv", id: "flv", value: "flv" },
  { label: "wmv", id: "wmv", value: "wmv" },
  { label: "webm", id: "webm", value: "webm" },
];

export const PLAN = {
  FREE: "free",
  LITE: "lite",
  STARTER: "starter",
  TEAM: "team",
  ENTERPRISE: "enterprise",
  TIER1: "tier1",
  TIER2: "tier2",
  TIER3: "tier3",
  TIER4: "tier4",
  TIER5: "tier5",
  PG_Tier1: "PG_Tier1",
  PG_Tier2: "PG_Tier2",
  PG_Tier3: "PG_Tier3",
  PG_Tier4: "PG_Tier4",
  PG_Tier5: "PG_Tier5",
  TIER6: "tier6",
  VD1: "vd1",
  VD2: "vd2",
  VDLTD: "vdltd",
  VDLTDA: "vdltdA",
  VDLTDB: "vdltdB",
  VDLTDC: "vdltdC"
};

export const PLAN_CONFIG = {
  SIZE_OPTIONS: {
    [PLAN.LITE]: 5 * 1024 * 1024 * 1024,  // 5GB
    [PLAN.STARTER]: 10 * 1024 * 1024 * 1024, // 10GB
    [PLAN.TEAM]: 10 * 1024 * 1024 * 1024, // 10GB
    [PLAN.TIER1]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.TIER2]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.TIER3]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.TIER4]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.TIER5]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.PG_Tier1]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.PG_Tier2]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.PG_Tier3]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.PG_Tier4]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.PG_Tier5]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.ENTERPRISE]: 50 * 1024 * 1024 * 1024, // 50GB
    [PLAN.TIER6]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VD1]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VD2]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VDLTD]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VDLTDA]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VDLTDB]: 4 * 1024 * 1024 * 1024, // 4GB
    [PLAN.VDLTDC]: 4 * 1024 * 1024 * 1024, // 4GB
  }
}

export const QUALITY_OPTIONS = (name, plan, exportquality) => {
  const quality = exportquality || ['4K', '2K', 'FHD', 'HD', 'SD'];
  switch (name) {
    case "horizontal":
      return [
        {
          label: "SD 480p",
          id: "480p",
          value: "pre0001",
          subtext: "Facebook Ad, Youtube Ad, LinkedIn Ad",
          name: "SD",
          isUpgrade: !(quality.indexOf("SD") > -1),

        },
        {
          label: "HD 720p",
          id: "720p",
          value: "pre0002",
          subtext: "Most Preferred",
          name: "HD",
          isUpgrade: !(quality.indexOf("HD") > -1),

        },
        {
          label: "Full HD 1080p",
          id: "1080p",
          value: "pre0003",
          subtext: "Audio: AAC 320kbps Stereo, 48000hz",
          name: "FHD",
          isUpgrade: !(quality.indexOf("FHD") > -1),
          icon: "starter.svg"
        },
        {
          label: "2k WQHD 1440p",
          id: "1440p",
          value: "pre0004",
          subtext: "Facebook Ad, Youtube Ad, LinkedIn Ad",
          name: "2K",
          isUpgrade: !(quality.indexOf("2K") > -1),
          icon: "team.svg"
        },
        {
          label: "4k Ultra HD 2160p",
          id: "2160p",
          value: "pre0005",
          subtext: "Facebook Ad, Youtube Ad, LinkedIn Ad",
          name: "4K",
          isUpgrade: !(quality.indexOf("4K") > -1),
          icon: "enterprice.svg"
        },
      ];
    case "vertical":
      return [
        {
          label: "SD 360p",
          id: "360p",
          value: "pre0006",
          subtext: "Select Resolution",
          name: "SD",
          isUpgrade: !(quality.indexOf("SD") > -1),

        },
        {
          label: "HD 720p",
          id: "720p",
          value: "pre0007",
          subtext: "Select Resolution",
          name: "HD",
          isUpgrade: !(quality.indexOf("HD") > -1),

        },
        {
          label: "Full HD 1080p",
          id: "1080p",
          value: "pre0008",
          subtext: "Select Resolution",
          name: "FHD",
          isUpgrade: !(quality.indexOf("FHD") > -1),
          icon: "starter.svg"
        },
        {
          label: "2k WQHD 1440p",
          id: "1440p",
          value: "pre0009",
          subtext: "Select Resolution",
          name: "2K",
          isUpgrade: !(quality.indexOf("2K") > -1),
          icon: "team.svg"
        },
        {
          label: "4k Ultra HD 2160p",
          id: "2160p",
          value: "pre0010",
          subtext: "Select Resolution",
          name: "4K",
          isUpgrade: !(quality.indexOf("4K") > -1),
          icon: "enterprice.svg"
        },
      ];
    default:
      return [
        {
          label: "SD 400p",
          id: "400p",
          value: "pre0011",
          subtext: "Select Resolution",
          name: "SD",
          isUpgrade: !(quality.indexOf("SD") > -1),

        },
        {
          label: "HD 600p",
          id: "600p",
          value: "pre0012",
          subtext: "Select Resolution",
          name: "HD",
          isUpgrade: !(quality.indexOf("HD") > -1),

        },
        {
          label: "Full HD 1080p",
          id: "1080p",
          value: "pre0013",
          subtext: "Select Resolution",
          name: "FHD",
          isUpgrade: !(quality.indexOf("FHD") > -1),
          icon: "starter.svg"
        },
        {
          label: "2k WQHD 1440p",
          id: "1440p",
          value: "pre0014",
          subtext: "Select Resolution",
          name: "2K",
          isUpgrade: !(quality.indexOf("2K") > -1),
          icon: "team.svg"
        },
        {
          label: "4k Ultra HD 2160p",
          id: "2160p",
          value: "pre0015",
          subtext: "Select Resolution",
          name: "4K",
          isUpgrade: !(quality.indexOf("4K") > -1),
          icon: "enterprice.svg"
        },
      ];
  }
};

export const DEFAULT_QUALITY_OPTIONS = (name, plan, exportquality) => {
  let value = null;
  switch (plan) {
    case PLAN.ENTERPRISE:
      value = QUALITY_OPTIONS(name, plan, exportquality)[2].value;
      break;
    case PLAN.TIER1:
    case PLAN.TIER2:
    case PLAN.TIER3:
    case PLAN.TIER4:
    case PLAN.TIER5:
    case PLAN.TEAM:
      value = QUALITY_OPTIONS(name, plan, exportquality)[1].value;
      break;
    case PLAN.STARTER:
      value = QUALITY_OPTIONS(name, plan, exportquality)[1].value;
      break;
    case PLAN.LITE:
      value = QUALITY_OPTIONS(name, plan, exportquality)[0].value;
      break;
    default:
      value = QUALITY_OPTIONS(name, PLAN.LITE, exportquality)[0].value;
      break;
  }
  return value;
};

export const APP_Z_INDICES = {
  workspaceWrapper: {
    default: 0,
    onPlay: 2,
  },
  timeline: {
    default: 3,
  },
  header: {
    default: 1,
    onPlay: "auto",
  },
  itemtoolbar: {
    default: 4,
  },
  itemtoolbarconfirm: {
    default: 5,
  },
  headerPreviewButton: {
    // inside header
    default: 3,
  },
  sidebar: {
    default: 1,
  },
  libraryDragItem: {
    default: 6,
  },
  customtooltip: {
    default: 99999,
  },
  playerbufferloader: {
    // inside workspace
    default: 999,
  },
  playerprogressloader: {
    // inside workspace
    default: 999,
  },
  colorpicker: {
    default: 998,
  },
};

export const KEYBOARD_SHORTCUTS_DATA = {
  Slides: [
    {
      name: "Add Scene",
      keys: ["Cmd", "M"],
    },
    {
      name: "Select Next Scene",
      keys: ["↓"],
    },
    {
      name: "Select Previous Scene",
      keys: ["↑"],
    },
    {
      name: "Move Scene Up",
      keys: ["↑"],
    },
    {
      name: "Move Scene Down",
      keys: ["↓"],
    },
    {
      name: "Move Scene First",
      keys: ["Cmd", "Shift", "↑"],
    },
    {
      name: "Move Scene Last",
      keys: ["Cmd", "Shift", "↓"],
    },
    {
      name: "Duplicate Scene",
      keys: ["Cmd", "D"],
    },
    {
      name: "Delete Scene",
      keys: ["Delete"],
    },
    {
      name: "Select Multiple Scene",
      keys: ["Cmd", "Click"],
    },
    {
      name: "Change Transition",
      keys: ["Shift", "T"],
    },
    {
      name: "Copy Scene With Audio",
      keys: ["Cmd", "Shift", "C"],
    },
  ],
  Timeline: [
    {
      name: "Increase Item Start 1 Sec",
      keys: ["Opt", "S"],
    },
    {
      name: "Decrease Item Start 1 Sec",
      keys: ["Opt", "A"],
    },
    {
      name: "Increase Item End 1 Sec",
      keys: ["Opt", "W"],
    },
    {
      name: "Decrease Item End 1 Sec",
      keys: ["Opt", "Q"],
    },
    {
      name: "Increase Enter Effect Time 1 Sec",
      keys: ["Shift", "Opt", "S"],
    },
    {
      name: "Decrease Enter Effect Time 1 Sec",
      keys: ["Shift", "Opt", "A"],
    },
    {
      name: "Increase Exit Effect Time 1 Sec",
      keys: ["Shift", "Opt", "W"],
    },
    {
      name: "Decrease Exit Effect Time 1 Sec",
      keys: ["Shift", "Opt", "Q"],
    },
    {
      name: "Change Enter Effect",
      keys: ["Opt", "←"],
    },
    {
      name: "Change Exit Effect",
      keys: ["Opt", "→"],
    },
    {
      name: "Increase Scene Duration",
      keys: ["Opt", "L"],
    },
    {
      name: "Decrease Scene Duration",
      keys: ["Opt", "K"],
    },
    {
      name: "Increase Playhead 1 Sec",
      keys: ["→"],
    },
    {
      name: "Decrease Playhead 1 Sec",
      keys: ["←"],
    },
    {
      name: "Increase Playhead 5 Sec",
      keys: ["Shift", "→"],
    },
    {
      name: "Decrease Playhead 5 Sec",
      keys: ["Shift", "←"],
    },
  ],
  Menubar: [
    {
      name: "Export Project",
      keys: ["Cmd", "E"],
    },
    {
      name: "Undo",
      keys: ["Cmd", "Z"],
    },
    {
      name: "Rndo",
      keys: ["Cmd", "Y"],
    },
  ],
  Text: [
    {
      name: "Align Right",
      keys: ["Cmd", "Shift", "R"],
    },
    {
      name: "Align Left",
      keys: ["Cmd", "Shift", "L"],
    },
    {
      name: "Align Center",
      keys: ["Cmd", "Shift", "E"],
    },
    {
      name: "To Uppercase",
      keys: ["Cmd", "Shift", "U"],
    },
    {
      name: "To Lowercase",
      keys: ["Cmd", "Shift", "S"],
    },
    {
      name: "To Capitalize",
      keys: ["Cmd", "Shift", "C"],
    },
    {
      name: "To Removecase",
      keys: ["Cmd", "'"],
    },
    {
      name: "Set Bold",
      keys: ["Cmd", "B"],
    },
    {
      name: "Set Italic",
      keys: ["Cmd", "|"],
    },
    {
      name: "Increase Font Size",
      keys: ["Cmd", "Shift", ">"],
    },
    {
      name: "Decrease Font Size",
      keys: ["Cmd", "Shift", "<"],
    },
    {
      name: "Change Font Family",
      keys: ["Cmd", "Shift", "F"],
    },
  ],
  Player: [
    {
      name: "Play/Pause",
      keys: ["Space"],
    },
    {
      name: "PlayAll/Pause",
      keys: ["Shift", "Space"],
    },
  ],
  Workspace: [
    {
      name: "Move Object Down 10px",
      keys: ["↓"],
    },
    {
      name: "Move Object Top 10px",
      keys: ["↑"],
    },
    {
      name: "Move Object Left 10px",
      keys: ["←"],
    },
    {
      name: "Move Object Right 10px",
      keys: ["→"],
    },
    {
      name: "Move Object Down 1px",
      keys: ["Shift", "↓"],
    },
    {
      name: "Move Object Top 1px",
      keys: ["Shift", "↑"],
    },
    {
      name: "Move Object Left 1px",
      keys: ["Shift", "←"],
    },
    {
      name: "Move Object Right 1px",
      keys: ["Shift", "→"],
    },
    {
      name: "Select All Objects",
      keys: ["Cmd", "A"],
    },
    {
      name: "Deselect All Objects",
      keys: ["Cmd", "Shift", "A"],
    },
    {
      name: "Select Multiple Objects",
      keys: ["Cmd", "Click"],
    },
    {
      name: "Copy Item",
      keys: ["Cmd", "C"],
    },
    {
      name: "Cut Item",
      keys: ["Cmd", "X"],
    },
    {
      name: "Paste Item",
      keys: ["Cmd", "V"],
    },
    {
      name: "Delete Item",
      keys: ["DeleteBackspace"],
    },
    {
      name: "Zoom In",
      keys: ["Cmd", "Opt", "+"],
    },
    {
      name: "Zoom Out",
      keys: ["Cmd", "Opt", "-"],
    },
    {
      name: "Bring Front",
      keys: ["Cmd", "Shift", "↑"],
    },
    {
      name: "Move Last",
      keys: ["Cmd", "Shift", "↓"],
    },
    {
      name: "Bring First",
      keys: ["Cmd", "↑"],
    },
    {
      name: "Move Back",
      keys: ["Cmd", "↓"],
    },
    {
      name: "Flip Item",
      keys: ["Opt", "F"],
    },
    {
      name: "Group Item",
      keys: ["Cmd", "Opt", "G"],
    },
    {
      name: "Ungroup Item",
      keys: ["Cmd", "Opt", "Shift", "G"],
    },
  ],
  Library: [
    {
      name: "Open Prebuild",
      keys: ["Shift", "1"],
    },
    {
      name: "Open Character",
      keys: ["Shift", "2"],
    },
    {
      name: "Open Properties",
      keys: ["Shift", "3"],
    },
    {
      name: "Open Text",
      keys: ["Shift", "4"],
    },
    {
      name: "Open Background",
      keys: ["Shift", "5"],
    },
    {
      name: "Open Image",
      keys: ["Shift", "6"],
    },
    {
      name: "Open Video",
      keys: ["Shift", "7"],
    },
    {
      name: "Open Bgm",
      keys: ["Shift", "8"],
    },
    {
      name: "Open Screen Effects",
      keys: ["Shift", "9"],
    },
    {
      name: "Open Uploads",
      keys: ["Shift", "U"],
    },
  ],
};
export const VIDEO_RESIZE_DETAILS = (theme) => {
  return {
    horizontal: {
      projectWidth: 800,
      projectHeight: 450,
      src:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="Group_78735" data-name="Group 78735" transform="translate(-96 -356)">
            <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
            <g id="Group_78734" data-name="Group 78734" transform="translate(98 361)">
              <path id="Path_85678" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
            </g>
            <g id="Group_78745" data-name="Group 78745" transform="translate(98 361)">
              <path id="Path_85678-2" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4v6A2.5,2.5,0,0,1,16,12.5H4A2.5,2.5,0,0,1,1.5,10V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
            </g>
          </g>
        </svg>`
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78735" data-name="Group 78735" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78734" data-name="Group 78734" transform="translate(98 361)">
          <path id="Path_85678" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78745" data-name="Group 78745" transform="translate(98 361)">
          <path id="Path_85678-2" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4v6A2.5,2.5,0,0,1,16,12.5H4A2.5,2.5,0,0,1,1.5,10V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
        </g>
      </g>
    </svg>`,
      selectedSrc:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78735" data-name="Group 78735" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78734" data-name="Group 78734" transform="translate(98 361)">
          <path id="Path_85678" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78745" data-name="Group 
        78745" transform="translate(98 361)">
          <path id="Path_85678-2" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4v6A2.5,2.5,0,0,1,16,12.5H4A2.5,2.5,0,0,1,1.5,10V4A2.5,2.5,0,0,1,4,1.5Z" fill="#fdc100" fill-rule="evenodd"/>
        </g>
      </g>
    </svg> 
    `
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_78735" data-name="Group 78735" transform="translate(-96 -356)">
      <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
      <g id="Group_78734" data-name="Group 78734" transform="translate(98 361)">
        <path id="Path_85678" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#e6f8ff" fill-rule="evenodd"/>
      </g>
      <g id="Group_78745" data-name="Group 78745" transform="translate(98 361)">
        <path id="Path_85678-2" data-name="Path 85678" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4v6a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4v6A2.5,2.5,0,0,1,16,12.5H4A2.5,2.5,0,0,1,1.5,10V4A2.5,2.5,0,0,1,4,1.5Z" fill="#00baff" fill-rule="evenodd"/>
      </g>
    </g>
  </svg>
  `,
      title: LANDSCAPE,
      name: "Landscape (16.9)",
    },
    vertical: {
      projectWidth: 450,
      projectHeight: 800,
      src:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78737" data-name="Group 78737" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78741" data-name="Group 78741" transform="translate(101 358)">
          <path id="Path_85685" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78744" data-name="Group 78744" transform="translate(101 358)">
          <path id="Path_85685-2" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5h6A2.5,2.5,0,0,1,12.5,4V16A2.5,2.5,0,0,1,10,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
        </g>
      </g>
    </svg>`
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_78737" data-name="Group 78737" transform="translate(-96 -356)">
      <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
      <g id="Group_78741" data-name="Group 78741" transform="translate(101 358)">
        <path id="Path_85685" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
      </g>
      <g id="Group_78744" data-name="Group 78744" transform="translate(101 358)">
        <path id="Path_85685-2" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5h6A2.5,2.5,0,0,1,12.5,4V16A2.5,2.5,0,0,1,10,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
      </g>
    </g>
  </svg>
  `,
      selectedSrc:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78737" data-name="Group 78737" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78741" data-name="Group 78741" transform="translate(101 358)">
          <path id="Path_85685" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78744" data-name="Group 78744" transform="translate(101 358)">
          <path id="Path_85685-2" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5h6A2.5,2.5,0,0,1,12.5,4V16A2.5,2.5,0,0,1,10,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#fdc100" fill-rule="evenodd"/>
        </g>
      </g>
    </svg>
    `
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_78737" data-name="Group 78737" transform="translate(-96 -356)">
      <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
      <g id="Group_78741" data-name="Group 78741" transform="translate(101 358)">
        <path id="Path_85685" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
      </g>
      <g id="Group_78744" data-name="Group 78744" transform="translate(101 358)">
        <path id="Path_85685-2" data-name="Path 85685" d="M0,4A4,4,0,0,1,4,0h6a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5h6A2.5,2.5,0,0,1,12.5,4V16A2.5,2.5,0,0,1,10,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#00baff" fill-rule="evenodd"/>
      </g>
    </g>
  </svg>
  `,
      title: POETRAIT,
      name: "Portrait (9:16)",
    },
    square: {
      projectWidth: 450,
      projectHeight: 450,
      src:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78739" data-name="Group 78739" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78742" data-name="Group 78742" transform="translate(98 358)">
          <path id="Path_85690" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78743" data-name="Group 78743" transform="translate(98 358)">
          <path id="Path_85690-2" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4V16A2.5,2.5,0,0,1,16,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
        </g>
      </g>
    </svg>
    `
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_78739" data-name="Group 78739" transform="translate(-96 -356)">
      <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
      <g id="Group_78742" data-name="Group 78742" transform="translate(98 358)">
        <path id="Path_85690" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
      </g>
      <g id="Group_78743" data-name="Group 78743" transform="translate(98 358)">
        <path id="Path_85690-2" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4V16A2.5,2.5,0,0,1,16,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#313445" fill-rule="evenodd"/>
      </g>
    </g>
  </svg>
  `,
      selectedSrc:
        theme === "light"
          ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_78739" data-name="Group 78739" transform="translate(-96 -356)">
        <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
        <g id="Group_78742" data-name="Group 78742" transform="translate(98 358)">
          <path id="Path_85690" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
        </g>
        <g id="Group_78743" data-name="Group 78743" transform="translate(98 358)">
          <path id="Path_85690-2" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4V16A2.5,2.5,0,0,1,16,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#fdc100" fill-rule="evenodd"/>
        </g>
      </g>
    </svg>
    `
          : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_78739" data-name="Group 78739" transform="translate(-96 -356)">
      <rect id="Rectangle_189815" data-name="Rectangle 189815" width="24" height="24" transform="translate(96 356)" fill="#fff" opacity="0"/>
      <g id="Group_78742" data-name="Group 78742" transform="translate(98 358)">
        <path id="Path_85690" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z" fill="#eaebf0" fill-rule="evenodd"/>
      </g>
      <g id="Group_78743" data-name="Group 78743" transform="translate(98 358)">
        <path id="Path_85690-2" data-name="Path 85690" d="M0,4A4,4,0,0,1,4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4ZM4,1.5H16A2.5,2.5,0,0,1,18.5,4V16A2.5,2.5,0,0,1,16,18.5H4A2.5,2.5,0,0,1,1.5,16V4A2.5,2.5,0,0,1,4,1.5Z" fill="#00baff" fill-rule="evenodd"/>
      </g>
    </g>
  </svg>
  `,
      title: SQUARE,
      name: "Square (1:1)",
    },
  };
};

export const VALID_IMAGE_TYPES = ["UPIMAGE", "STOCKIMG", "PIXABAY", "PEXELS"];

export const ANIMO_RENDER_TYPES = ["PROP", "SHAPE", "TEXT"];

export const DEFAULT_FILTER_CODE = "6464646464640032";

export const PROJECT_CONTAINERS = ["workspaceItems", "audios"];

export const isImageSubtypeOnly = (subType) => {
  return (
    subType === "IMAGE" ||
    subType === "ISESS" ||
    subType === "ISSIG" ||
    subType === "GETTY" ||
    subType === "RECORD"
  );
};

export const colors = {
  highlightText: "#54536E",
  Green: "#2AC79A",
  white: "#FFFFFF",
  OrangeDark: "#FF7F00",
};

export const teamBgColor = {
  [PLAN.LITE]: "#ebecf0",
  [PLAN.STARTER]: "rgb(255, 195, 0)",
  [PLAN.TIER1]: "rgb(89, 211, 255)",
  [PLAN.TIER2]: "rgb(89, 211, 255)",
  [PLAN.TIER3]: "rgb(89, 211, 255)",
  [PLAN.TIER4]: "rgb(89, 211, 255)",
  [PLAN.TIER5]: "rgb(89, 211, 255)",
  [PLAN.TEAM]: "rgb(89, 211, 255)",
  [PLAN.ENTERPRISE]: "#C790FA",
};

export const teamTextColor = {
  [PLAN.LITE]: "#000",
  [PLAN.STARTER]: "#fff",
  [PLAN.TIER1]: "#fff",
  [PLAN.TIER2]: "#fff",
  [PLAN.TIER3]: "#fff",
  [PLAN.TIER4]: "#fff",
  [PLAN.TIER5]: "#fff",
  [PLAN.TEAM]: "#fff",
  [PLAN.ENTERPRISE]: "#fff",
};

export const iconPlan = {
  [PLAN.LITE]: "",
  [PLAN.STARTER]: `${STATIC_PATH}white-star.png`,
  [PLAN.TIER1]: `${STATIC_PATH}white-star.png`,
  [PLAN.TIER2]: `${STATIC_PATH}white-star.png`,
  [PLAN.TIER3]: `${STATIC_PATH}white-star.png`,
  [PLAN.TIER4]: `${STATIC_PATH}white-star.png`,
  [PLAN.TIER5]: `${STATIC_PATH}white-star.png`,
  [PLAN.TEAM]: `${STATIC_PATH}white-star.png`,
  [PLAN.ENTERPRISE]: `${STATIC_PATH}white-star.png`,
};

export const plans = {
  [PLAN.STARTER]: "#FFC300",
  [PLAN.ENTERPRISE]: "#D4AFFF",
  [PLAN.LITE]: "#D8D8D8",
  [PLAN.TEAM]: "#5AD4FF",
  [PLAN.TIER1]: "#5AD4FF",
  [PLAN.TIER2]: "#5AD4FF",
  [PLAN.TIER3]: "#5AD4FF",
  [PLAN.TIER4]: "#5AD4FF",
  [PLAN.TIER5]: "#5AD4FF",
};

const DOWNLOAD_SUBMENU = [
  { name: ".SRT format", actionName: "SRT" },
  { name: ".VTT format", actionName: "VTT" },
  { name: ".SBV format", actionName: "SBV" },
  { name: ".ASS format", actionName: "ASS" },
];

export const SUBTITLE_MENU_OPTIONS = [
  {
    icon: "sm-vm-download.svg",
    name: "Download",
    actionName: "DOWNLOAD",
    subOptions: DOWNLOAD_SUBMENU,
  },
  { icon: "sm-vm-delete.svg", name: "Delete", actionName: "DELETE" },
];

export const HEADER_MENU = [
  { icon: "vm-upload.svg", name: "Upload Subtitle", actionName: "UPLOAD" },
  {
    icon: "sm-vm-download.svg",
    name: "Download",
    actionName: "DOWNLOAD",
    subOptions: DOWNLOAD_SUBMENU,
  },
  {
    icon: "sm-vm-delete.svg",
    name: "Clear subtitle",
    actionName: "CLEAR_ALL",
  },
];

export const PLAN_CONTENT = {
  [PLAN.STARTER]: {
    default: [
      "Everything in Lite plus",
      "Remove green screen",
      "5 GB upload storage limit",
      "Auto Subtitles 60 mins/month",
      "Export in 1080p resolution",
    ],
    durationExceed: [
      "Everything in Lite plus",
      "30 min video export length",
      "Green screen removal",
      "5 GB upload storage limit",
      "Auto Subtitles 45 mins/month",
      "10 video exports per month",
      "Export in 1080p resolution",
    ],
    resolutionExceed: [
      "Everything in Lite plus",
      "Export in 1080p resolution",
      "30 min video export length",
      "Green screen removal",
      "5 GB upload storage limit",
      "Auto Subtitles 45 mins/month",
      "10 video exports per month",
    ],
    avatarVoice: [
      "Everything in Lite plus",
      "80 AI Avatars",
      "3 min/ month video generation",
      "Standard Avatar voices",
      "1080p Video Export Quality ",
      "60 min per month auto subtitles ",
      "10 video exports per month"
    ],
    header: [
      {
        text: "2,000 Long to Short Form AI Credits",
        tooltip: "Approx 200 mins video processing / month. Varies based on usage."
      },
      "1080p export quality",
      "60 mins auto subtitle/month",
      "Watermark-free videos",
      "80 AI Avatars",
      "36 mins Gen AI credits/year",
      "10 video downloads/month",
      "29 premium assets/month",
      "10 GB upload storage",
      "Chat support"
    ]
  },
  // For TEAM, TIER1, TIER2, TIER3, TIER4, TIER5, PG_Tier1, PG_Tier2, PG_Tier3, PG_Tier4, PG_Tier5
  ...['TEAM', 'TIER1', 'TIER2', 'TIER3', 'TIER4', 'TIER5', 'PG_Tier1', 'PG_Tier2', 'PG_Tier3', 'PG_Tier4', 'PG_Tier5']
    .reduce((acc, planType) => {
      acc[PLAN[planType]] = {
        default: [
          "Everything in Starter plus",
          "Remove video background (15 mins/month)",
          "30 GB upload storage limit",
          "Auto Subtitles 120 mins/month",
          "Export in 2k resolution",
          "30 Video exports per month",
        ],
        durationExceed: [
          "Everything in Starter plus",
          "45 min video export length",
          "Video background Removal 15 mins/month",
          "30 GB upload storage limit",
          "Auto Subtitle 90 min/month",
          "30 video exports per month",
          "Export in 2k resolution"
        ],
        resolutionExceed: [
          "Everything in Starter plus",
          "Export in 2k resolution",
          "45 min video export length",
          "Video background Removal 15 mins/month",
          "30 GB upload storage limit",
          "Auto Subtitle 90 min/month",
          "30 video exports per month",
        ],
        avatarVoice: [
          "Everything in Starter plus",
          "99 AI Avatars",
          "12 min/ month video generation",
          "200 Premium voices",
          "2k Video export quality",
          "120 min per month auto subtitle",
          "30 video exports per month"
        ],
        header: [
          {
            text: "3,500 Long to Short Form AI Credits",
            tooltip: "Approx 350 mins video processing / month. Varies based on usage."
          },
          "2K export quality",
          "120 mins auto subtitle/month",
          "Watermark-free videos",
          "99 AI Avatars",
          "144 mins Gen AI credits/year",
          "30 video downloads/month",
          "60 premium assets/month",
          "200+ premium voices",
          "30 GB upload storage",
          "Priority support"
        ]
      };
      return acc;
    }, {}),
  [PLAN.ENTERPRISE]: {
    default: [
      "Everything in Teams plus",
      "Custom credits for video background removal",
      "50+ GB upload storage limit",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Unlimited video exports"
    ],
    durationExceed: [
      "Everything in Teams plus",
      "Custom credits for video background removal",
      "50+ GB upload storage limit",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Unlimited video exports"
    ],
    resolutionExceed: [
      "Everything in Teams plus",
      "Custom credits for video background removal",
      "50+ GB upload storage limit",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Unlimited video exports"
    ],
    avatarVoice: [
      "Everything in Teams plus",
      "150+ AI Avatars",
      "1000 min per year video generation",
      "500+ premium voices with accents",
      "4k Video export quality",
      "2000 min per year subtitle generation",
      "Unlimited video exports",
      "Custom Avatars"
    ],
    header: [
      "Custom Long to Short Form AI Credits",
      "4K export quality",
      "Custom auto-subtitle & translation credits",
      "Watermark-free videos",
      "50+ GB upload storage",
      "Custom Gen AI credits",
      "Custom premium assets",
      "Unlimited video exports",
      "Dedicated account manager",
      "Personal onboarding",
      "Custom CTA & custom domain"
    ]
  }
};


export const PLAN_TYPES = [
  {
    icon: "starter-icon.svg",
    name: "Starter",
    plan: PLAN.STARTER,
    titleSubtext: "If you are just getting started",
    action: "Upgrade to Starter",
    actionBgColor: "#00BAFF",
  },
  {
    icon: "teams-icon.svg",
    name: "Teams",
    plan: PLAN.TEAM,
    titleSubtext: "The Pros and the ones to be",
    action: "Upgrade to Teams",
    actionBgColor: "#00BAFF",
  },
  {
    icon: "enterprise-icon.svg",
    name: "Enterprise Plan",
    plan: PLAN.ENTERPRISE,
    titleSubtext: "",
    action: "Contact Us",
    description: "Go beyond the standard with larger pool of credits and custom features.",
    avatarDescription: "Scale your video creation with custom credits and AI Avatars",
    actionBgColor: "#00BAFF",
    text: "Switch to our Enterprise Plan!",
    cycle: "Custom"
  },
];

export const APP_INTEGRATION = [
  {
    name: PANEL.PEXELS,
    title: content.PEXELS,
    src: "vm-pexels.svg",
    content: "Import pictures from Pexels",
  },
  {
    name: PANEL.PIXABAY,
    src: "vm-pixabay.svg",
    content: "Import pictures from Pixabay",
    title: content.PIXABAY,
  },
  {
    name: PANEL.PEXELS_VIDEO,
    src: "vm-pexels.svg",
    content: "Import videos from Pexels",
    title: content.PEXELS_VIDEO,
  },
  {
    name: PANEL.PIXABAY_VIDEO,
    src: "vm-pixabay.svg",
    content: "Import videos from Pixabay",
    title: content.PIXABAY_VIDEO,
  },
  {
    name: PANEL.UNSPLASH,
    src: "vm-unsplash.svg",
    content: "Import pictures from Unsplash",
    title: content.UNSPLASH,
  },
  {
    name: PANEL.GIPHY,
    src: "giphy.svg",
    content: "Add gifs from giphy to designs",
    title: content.GIPHY,
  },
  {
    name: PANEL.FAVORITES,
    src: `left-menu-fav.svg`,
    title: content.FAVORITES,
    content: "Selected favourites display in one place"
  }
];

export const FAVOURITES_LIMIT = {
  PROPERTY: 8,
  MUSIC: 4,
  IMAGE: 4,
  VIDEO: 4
};

export const ONBOARDING_CONTENT = {
  ANYOTHER_PLEASE_SPECIFY: "Any other (please specify)",
  PERSONAL: "Personal use",
  PROFESSIONAL: "Professional use"
};

export const PLAN_PRISING_RES = {
  "starter": {
    "monthly": 24,
    "yearly": 216
  },
  "team": {
    "monthly": 39,
    "yearly": 300
  }
};

export const LFTS_SUPPORTED_URL_PLATFORMS = [
  { id: "title", label: "Drop a video link from", icon: "" },
  { id: "youtube", label: "YouTube", icon: "w-youtube.svg" },
  { id: "google-drive", label: "Google Drive", icon: "w-drive.svg" },
  { id: "tiktok", label: "TikTok", icon: "w-tiktok.svg" },
  { id: "dropbox", label: "Dropbox", icon: "dropbox-tile.svg" },
  { id: "twitch", label: "Twitch", icon: "w-twitch.svg" },
  { id: "zoom", label: "Zoom", icon: "w-zoom.svg" },
  { id: "vimeo", label: "Vimeo", icon: "w-vimeo.svg" },
  { id: "wistia", label: "Wistia", icon: "wistia.svg" },
  { id: "streamyard", label: "StreamYard", icon: "w-streamyard.svg" },
  { id: "loom", label: "Loom", icon: "w-loom.svg" },
  { id: "twitter", label: "Twitter", icon: "w-twitter.svg" },
  { id: "facebook", label: "Facebook", icon: "facebook.svg" },
  { id: "riverside", label: "Riverside", icon: "w-riverside.svg" },
];

export const BUSSINESS_DOMAINS = ["animaker", "picmaker", "steve", "google", "gmail", "yahoo", "qq", "hotmail", "icloud",
  "comcast", "yopmail", "live", "freemail", "me", "ymail", "outlook", "rediffmail", "yopmail", "GMAIL", "gamil", "googlemail", "g00glemail", "googlmail",
  "gmail", "icloud", "proton", "gmail", "icloud", "aol", "msn", "zoho", "fastmail", "hushmail", "gmx", "mail", "inbox", "mail", "rambler", "web", "tutanota", "runbox", "gmal",
  "gmial", "gmaill", "outlok", "hotmal", "yahho", "yaho", "10minutemail", "guerrillamai", "temp-mail", "getnada", "mailinator", "trashmail",
  "fakeinbox", "moakt", "dispostable", "sharklasers", "throwawaymail",];

export const SOCIAL_MEDIA_OPTIONS = [
  { icon: "delete-icon.svg", name: "Delete", actionName: "DELETE" },
];

export const queuePhaseMessages = [
  "Connecting to server...",
  "Initiating project export...",
  "Adding your request to the export..",
  "Request successfully added...",
  "....",
  "Project added to queue...",
  "Polling machines to render this project..",
  "....",
  "Assigning machine..",
  "This could take a few minutes..."
];

export const phase1Messages = [
  "Connecting to server...",
  "Phase 1",
  "Gathering project information",
  "....",
  "Downloading project frame information",
  "....",
  "Verifying uploads",
  "Render machine found and assigned",
  "....",
  "Stack files sent to render machine",
  "Submission successful",
  "....",
  "Staging assets, videos and properties",
  "Integrating high-quality assets to your video render..",
  "Assembling layers..",
  "Processing all the layers parallelly..",
  "Merging all the layers together..",
  "Stream #0:0 -> #0:0 (h264 (native) -> png (native))...",
  "Auto tuning project for better compression output",
  "exportId: $exportId",
  "format: mp4",
  `projectWidth:`,
  `projectHeight: `,
  "Loading next steps.."
];

export const phase2Updates = [
  "Connecting to server...",
  "Initiating Phase 2..",
  "....",
  "Initiating H.264 video compression..",
  "....",
  "Checking project for audio files.",
  "Audio files found...",
  "....",
  "Stream #0:0(eng): Video: png, rgb24, libx265, [SAR 1:1 DAR 16:9], q=2-31, 200 kb/s, 23.98 fps, 23.98 tbn, 23.98 tbc (default)",
  "Stream mapping:",
  "Map successful...",
  "....",
  "Download_source_audio",
  "Input #0, audio,",
  "Duration: 00:00:00.04, start: 0.000000, bitrate: 1038878 kb/s",
  "Stream#0:0: Video: mjpeg (Baseline), yuvj444p(pc, bt470bg/unknown/unknown), 4948x3299 [SAR 300:300 DAR 4948:3299], 25 tbr, 25 tbn, 25 tbc",
  "Stream mapping:",
  "Stream #0:0 -> #0:0 (mjpeg (native) -> mjpeg (native))"
];

export const phase3Updates = [
  "Connecting to server...",
  "Phase 3",
  "Upload started",
  "....",
  "Validating Export id",
  "....",
  "Validation successful",
  "....",
  "Initiating streaming files...",
  "generating streaming files with different streaming versions...",
  "....",
  "Generating successful...",
  "Creating download link..."
];

export const CIRCLE_FRAME = {
  "clipDetails": {
    "clip_1": {
      "imgDetails": {},
      "clipData": "M60.74,30.37v.22a31.35,31.35,0,0,1-.64,6,30.23,30.23,0,0,1-2,6.06l-.19.42a3.56,3.56,0,0,1-.64,1.31,28.93,28.93,0,0,1-1.49,2.53l-.27.44a30.39,30.39,0,0,1-3.29,4,29.47,29.47,0,0,1-2.15,2c-.5.43-1,.85-1.54,1.25s-1.21.86-1.83,1.26a30.38,30.38,0,0,1-31.32.86l-1-.57-.87-.56a29.67,29.67,0,0,1-3.85-3c-.51-.47-1-1-1.48-1.47L8,50.86c-.49-.53-1-1.09-1.41-1.67-.24-.29-.47-.58-.69-.89a29.19,29.19,0,0,1-1.78-2.74l0,0c-.15-.25-.29-.5-.43-.75l0-.05a29.54,29.54,0,0,1-1.42-3.07A30.43,30.43,0,0,1,2.63,18,30.6,30.6,0,0,1,12.21,6a31.12,31.12,0,0,1,7-3.89,30.37,30.37,0,0,1,41.55,28Z",
      "clipWidth": 60.742,
      "clipY": 0,
      "clipX": 0,
      "clipHeight": 60.742
    }
  },
  "thumbnail": "frame-0003.png",
  "d": [],
  "asset_type": 0,
  "width": 60.742,
  "id": "frame-0003",
  "type": "FRAME",
  "height": 60.742,
  "name_en": "Frame",
  "is_fav": false
};

export const DEFAULT_FRAME_BG = "#C1C1C1";

export const bytesToGB = (bytes) => {
  const gb = bytes / (1024 * 1024 * 1024);
  return gb % 1 === 0 ? gb.toFixed(0) : gb.toFixed(2);
};

export const bytesToMB = (bytes) => {
  const mb = bytes / (1024 * 1024);
  return mb % 1 === 0 ? mb.toFixed(0) : mb.toFixed(2);
};

export const getSupportedFilesContent = (plans) => {
  const maxSizeBytes = PLAN_CONFIG.SIZE_OPTIONS[plans];
  let maxSize;
  let unit;

  if (plans === PLAN.LITE) {
    maxSize = bytesToMB(maxSizeBytes);
    unit = "MB";
  } else {
    maxSize = bytesToGB(maxSizeBytes);
    unit = "GB";
  }
  return `${maxSize} ${unit}`;
};

export const gradientArray = [
  "right",
  "bottom right",
  "bottom",
  "bottom left",
  "left",
  "top left",
  "top",
  "top right",
];

export const radiusArray = [1, 10, 25, 50, 75];

export const defaultFolders = [
  {
    _source: {
      name: "Recordings",
      _id: "RECORDING",
      parent: 0,
      fpriority: true,
    },
  },
  {
    _source: {
      name: "Exports",
      _id: "EXPORT",
      parent: 0,
      fpriority: true,
    },
  },
];

export const PLAN_LIMITS = {
  BG_NOISE: {
    [PLAN.LITE]: 120,
    [PLAN.STARTER]: 300,
  }
};

export const SYMBOL = { default: "$", IN: "₹" }

export const subCancelSubText = [
  "Extended recording  duration ",
  "Advanced Privacy and Security",
  "Computer audio recording (essential for meetings)",
  "Virtual background and advanced frames for webcam overlay",
  "Drawing tool and mouse emphasis"
]

export const downgradeToStarter = [
  "Custom logo, brand colours and subdomain on player page",
  "Folder creation on dashboard",
  "Auto expiry for videos",
  "Advanced editing features",
  "Real-time collaboration"
]

export const downgradeToLite = [
  "Extended recording duration",
  "Advanced privacy and security",
  "Computer audio recording (essential for meetings)",
  "Virtual background and frames",
  "4K recording resolution"
]


export const PRICING_MODAL_CONTENT = {
  header: {
    text: "Upgrade to unlock premium features",
    img: "common-upgrade-button.png",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: "Generative Credits"
    },
    enterprise: 'Custom',
    enterpriseImage: "common-upgrade-enterprises.webp",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "AI Avatar video generation",
      "AI video dubbing",
      "50+ GB upload storage limit",
      "Custom credits for video background removal",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Webcam + screen recording",
      "Custom video generation credits",
      "Custom video exports",
      "Export up to 4k video resolution",
      "Brand kit"
    ]
  },
  download: {
    text: "Upgrade to download your videos",
    img: "download-price-modal.png",
    cycleData: {
      starter: '10/mo',
      team: '30/mo',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Total Video Downloads',
      team: 'Total Video Downloads',
      enterprise: "Total Video Downloads"
    },
    enterpriseImage: "download-price-modal.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom video exports",
      "50+ GB upload storage limit",
      "Custom credits for stock assets",
      "100+ AI Avatars",
      "Custom video generative credits",
      "Doc to video",
      "Video dubbing",
      "Custom credits for auto-subtitle and translation",
      "Custom credits for video background removal",
      "Priority support",
    ]
  },
  socialPublish: {
    text: "Upgrade to publish your videos",
    img: "youtube-publish.webp",
    cycleData: {
      starter: '10/mo',
      team: '30/mo',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Total social publish',
      team: 'Total social publish',
      enterprise: "Total social publish"
    },
    enterpriseImage: "youtube-publish.webp",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom video exports",
      "50+ GB upload storage limit",
      "Custom credits for stock assets",
      "100+ AI Avatars",
      "Custom video generative credits",
      "Doc to video",
      "Video dubbing",
      "Custom credits for auto-subtitle and translation",
      "Custom credits for video background removal",
      "Priority support",
    ]
  },
  publish: {
    text: "Upgrade to publish your videos",
    img: "youtube-publish.png",
    cycleData: {
      starter: '10/mo',
      team: '30/mo',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Total YouTube Publish',
      team: 'Total YouTube Publish',
      enterprise: "Total YouTube Publish"
    },
    enterpriseImage: "youtube-publish.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom video exports",
      "50+ GB upload storage limit",
      "Custom credits for stock assets",
      "100+ AI Avatars",
      "Custom video generative credits",
      "Doc to video",
      "Video dubbing",
      "Custom credits for auto-subtitle and translation",
      "Custom credits for video background removal",
      "Priority support"
    ]
  },
  resolutionExceed: {
    text: "Upgrade to unlock High quality video exports",
    img: "export-options.png",
    cycleData: {
      starter: 'Full HD 1080p',
      team: '2k',
      enterprise: '4k',
    },
    subText: {
      starter: 'Video Export Quality',
      team: 'Video Export Quality',
      enterprise: "Video Export Quality"
    },
    enterpriseImage: "export-options.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Export in 4K HD",
      "Custom video exports",
      "50+ GB upload storage limit",
      "100+ AI Avatars ",
      "Custom video generative credits ",
      "Doc to video",
      "Video dubbing",
      "Custom credits for auto-subtitle and translation",
      "Custom credits for video background removal",
      "Priority support"
    ]
  },
  premiumAsset: {
    text: "You’re out of credit for premium assets!",
    img: "premium-assets.png",
    cycleData: {
      starter: '29/mo',
      team: '60/mo',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Premium Assets',
      team: 'Premium Assets',
      enterprise: "Premium Assets"
    },
    enterpriseImage: "common-upgrade-enterprise.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom credits for stock assets",
      "Custom video exports",
      "50+ GB upload storage limit",
      "100+ AI Avatars",
      "Custom video generative credits",
      "Doc to video",
      "Video dubbing",
      "Custom credits for auto-subtitle and translation",
      "Custom credits for video background removal",
      "Priority support"
    ]
  },
  bgRemoval: {
    title: "Upgrade to remove video background",
    img: "vm-price-bgremovals.png",
    starter: '15 mins/month',
    team: '15 mins/month',
    enterprise: 'Custom',
    enterpriseImage: "vm-price-bgremoval-enterprises.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom credits for video background removal",
      "AI Avatar video generator",
      "AI video dubbing",
      "50+ GB upload storage limit",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Custom video generation credits",
      "Webcam + screen recorder",
      "Custom video exports",
      "Export up to 4k video resolution",
      "Brand kit"
    ]
  },
  watermark: {
    text: "Upgrade to remove watermark",
    img: "watermark-modal.webp",
    enterpriseImage: "watermark-modal.webp",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: "Custom"
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: "Generative Credits"
    },
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  longtoshort: {
    text: "Not enough credits for AI Long form to shorts form",
    enterpriseImage: "long-form-upgrade.webp",
    img: "long-form-upgrade.webp",
    cycleData: {
      starter: '2000 credits/month',
      team: '3500 credits/month',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: "Generative Credits",
    },

    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  reframe: {
    text: "Upgrade to export with AI Reframe",
    enterpriseImage: "ai-reframe-img.webp",
    img: "ai-reframe-img.webp",
    cycleData: {
      starter: '2000 credits/month',
      team: '3500 credits/month',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'AI Reframe Credits',
      team: 'AI Reframe Credits',
      enterprise: "AI Reframe Credits",
    },

    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  reframeApply: {
    text: "Upgrade to Apply AI Reframe",
    enterpriseImage: "ai-reframe-img.webp",
    img: "ai-reframe-img.webp",
    cycleData: {
      starter: '2000 credits/month',
      team: '3500 credits/month',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'AI Reframe Credits',
      team: 'AI Reframe Credits',
      enterprise: "AI Reframe Credits",
    },

    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  avatarVoice: {
    text: "Upgrade to unlock premium AI voices",
    img: "premium-voice.webp",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: "Premium AI voices",
    },
    enterpriseImage: "premium-voice.webp",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  premiumCharacter: {
    text: "Upgrade to Unlock premium AI Avatars",
    img: "premium-character.png",
    cycleData: {
      starter: '80',
      team: '99',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Total Avatars included',
      team: 'Total Avatars included',
      enterprise: "Total Avatars included",
    },
    enterpriseImage: "premium-character.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  premiumAvatarExhausted: {
    text: "Looks like out of generative credits",
    img: "premium-character.png",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: 'Generative Credits',
    },
    enterpriseImage: "premium-character.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  premiumAvatarCredits: {
    text: "Looks like out of generative credits",
    img: "premium-character.png",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: 'Generative Credits',
    },
    enterpriseImage: "premium-character.png",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Premium AI voices",
      "Custom video generative credits",
      "100+ Avatars",
      "Custom clone Avatars",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50 + GB storage",
      "Priority support",
      "Custom video exports",
    ]
  },
  customAvatar: {
    text: "Looks like out of generative credits",
    img: "custom-avatar.webp",
    cycleData: {
      starter: '36 mins/year',
      team: '144 mins/year',
      enterprise: 'Custom',
    },
    subText: {
      starter: 'Generative Credits',
      team: 'Generative Credits',
      enterprise: 'Generative Credits',
    },
    enterpriseImage: "custom-avatar.webp",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "Custom clone Avatars",
      "100+ Stock Avatars",
      "50+ Ethnicities",
      "Video dubbing",
      "Doc to video converter",
      "Custom credits for auto-subtitle and translation",
      "50+ GB storage",
      "Priority support",
      "Custom video exports"
    ]
  },
  subtitleTranslation: {
    text: "You're out of subtitle translation credits!",
    img: "subtitle-translate.webp",
    cycleData: {
      starter: '60 mins/month',
      team: '120 mins/month',
    },
    subText: {
      team: 'subtitle translation',
      starter: 'subtitle translation',
    },
    enterpriseImage: "subtitle-credits-enterprise.webp",
    enterpriseFeatures: [
      "Everything in Team plus",
      "Custom credits for auto-subtitle and translation",
      "50+ GB Upload Storage limit",
      "Priority Support",
      "Custom video generative credits",
      "100+ Avatars",
      "Video Dubbing",
      "Doc to video",
      "Custom video exports"
    ]
  },
  upgradeSubtitle: {
    text: "You're out of subtitle generation credits!",
    img: "subtitle-credits.webp",
    cycleData: {
      starter: '60 mins/month',
      team: '120 mins/month',
    },
    subText: {
      starter: 'Auto Subtitle',
      team: 'Auto Subtitle'
    },
    enterpriseImage: "subtitle-credits-enterprise.webp",
    enterpriseFeatures: [
      "Everything in Team plus",
      "Custom credits for auto-subtitle and translation",
      "50+ GB Upload Storage limit",
      "Priority Support",
      "Custom video generative credits",
      "100+ Avatars",
      "Video Dubbing",
      "Doc to video",
      "Custom video exports"
    ]
  },
  file_restriction: {
    text: "File too large! Upgrade your plan to continue",
    img: "file-restriction.webp",
    cycle: '10GB',
    subText: 'Max upload size',
    enterprise_cycle: '50GB',
    enterpriseImage: "enterprise-file-restriction.webp",
    enterpriseFeatures: [
      "Everything in Teams plus",
      "AI Avatar video generation",
      "AI video dubbing",
      "Upload file size up to 50 GB or 3 hrs per upload",
      "Custom credits for video background removal",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Webcam + screen recording",
      "Custom video generation credits",
      "Custom video exports",
      "Export up to 4k video resolution",
      "Brand kit"
    ]
  },
  default: {
    text: "Upgrade to unlock premium features",
    cycle: '36 mins/year',
    subText: 'Generative Credits',
    enterpriseImage: "common-upgrade-enterprises.webp",
    img: "common-upgrade-button.png",
    enterprise_cycle: 'Custom',
    enterpriseFeatures: [
      "Everything in Teams plus",
      "AI Avatar video generation",
      "AI video dubbing",
      "50+ GB upload storage limit",
      "Custom credits for video background removal",
      "Custom credits for auto-subtitle and translation",
      "Priority support",
      "Webcam + screen recording",
      "Custom video generation credits",
      "Custom video exports",
      "Export up to 4k video resolution",
      "Brand kit"
    ]
  }
};

const VALID_FLOW_TYPES = [
  "raw_to_wow",
  "raw_to_wow_sample",
  "raw_to_highlights",
  "raw_to_highlights_sample",
  "Shorts",
  "Shorts_sample",
  "shorts_new",
  "viral_style",
  "viral_style_sample",
  "hlights_sample",
  "AVATAR",
  "video_dubbing",
  "prompt-to-video",
  "broll"
];

export const SHORTS_FLOW_SOURCE_TYPES = [
  "Shorts",
  "Shorts_sample",
  "shorts_new",
];

export function isShortsFlowSourceType(sourceType) {
  return SHORTS_FLOW_SOURCE_TYPES.includes(sourceType);
}

/*
  @param {string} sourceType - The source type to check
  @returns {boolean} - True if the source type is valid, false otherwise
*/

export function isValidFlowType(sourceType) {
  return VALID_FLOW_TYPES.includes(sourceType);
}


export const REFRAME_LAYOUT = {
  "FILL": {
    "name": "Fill",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "Fill",
        "ratio": "9:16",
        "x": 0,
        "y": 0,
        "width": 450,
        "height": 800
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "FIT": {
    "name": "Fit",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "Fit",
        "ratio": "9:16",
        "x": 0,
        "y": 267.50144927536223,
        "width": 450,
        "height": 252.92740046838406
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "SPLIT": {
    "name": "Split",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "top",
        "ratio": "9:8",
        "x": 0,
        "y": 0,
        "width": 450,
        "height": 400
      },
      {
        "label": "bottom",
        "ratio": "9:8",
        "x": 0,
        "y": 400,
        "width": 450,
        "height": 400
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "THREE": {
    "name": "Three",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "left",
        "ratio": "9:16",
        "x": 0,
        "y": 0,
        "width": 450,
        "height": 400
      },
      {
        "label": "right_top",
        "ratio": "9:8",
        "x": 0,
        "y": 400,
        "width": 225,
        "height": 400
      },
      {
        "label": "right_bottom",
        "ratio": "9:8",
        "x": 225,
        "y": 400,
        "width": 225,
        "height": 400
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "FOUR": {
    "name": "Four",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "top_left",
        "ratio": "9:8",
        "x": 0,
        "y": 0,
        "width": 225,
        "height": 400
      },
      {
        "label": "top_right",
        "ratio": "9:8",
        "x": 225,
        "y": 0,
        "width": 225,
        "height": 400
      },
      {
        "label": "bottom_left",
        "ratio": "9:8",
        "x": 0,
        "y": 400,
        "width": 225,
        "height": 400
      },
      {
        "label": "bottom_right",
        "ratio": "9:8",
        "x": 225,
        "y": 400,
        "width": 225,
        "height": 400
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "SCREENSHARE": {
    "name": "Screen Share",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "top",
        "ratio": "1:1.88",
        "x": 0,
        "y": 0,
        "width": 450,
        "height": 500
      },
      {
        "label": "bottom",
        "ratio": "1:1.24",
        "x": 0,
        "y": 500,
        "width": 450,
        "height": 300
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  },
  "GAMEPLAY": {
    "name": "Screen Share",
    "canvas": {
      "width": 1080,
      "height": 1920
    },
    "boxes": [
      {
        "label": "top",
        "ratio": "1:1.88",
        "x": 0,
        "y": 0,
        "width": 450,
        "height": 500
      },
      {
        "label": "bottom",
        "ratio": "1:1.24",
        "x": 0,
        "y": 500,
        "width": 450,
        "height": 300
      }
    ],
    "scale": "pixel",
    "ratio": "9:16"
  }
}

export function formatPriceByLocale(price) {
  return Number(price).toLocaleString();
}

export const VIRAL_FEATURES = [
  {
    id: "reframe",
    label: content.SHORTS_REFRAME,
    icon: "reframes.svg",
    description: content.REFRAME_FEATURE_DESCRIPTION,
    disabled: false,
    badge: content.COMING_SOON,
    badgeVariant: "starter",
  },
  {
    id: "ccStyles",
    label: content.SHORTS_CC_STYLES,
    icon: "cc-icons.svg",
    description: content.SUBTITLES_ANIMATED_CAPTIONS,
    upgradeType: "upgradeSubtitle",
    upgradeSource: "Shorts-cc-styles",
    opensPreset: true,
    badgeVariant: "starter",
  },
  {
    id: "dubbing",
    label: content.SHORTS_DUBBING,
    icon: "translate-icons.svg",
    description: content.DUBBING_ANIMATED_CAPTIONS,
    upgradeType: "subtitleTranslation",
    upgradeSource: "Shorts-dubbing",
    badgeVariant: "team",
  },
  {
    id: "bRoll",
    label: content.SHORTS_B_ROLL,
    icon: "four-frames.svg",
    description: content.B_ROLL_ANIMATED_CAPTIONS,
    upgradeType: "longtoshort",
    upgradeSource: "Shorts-broll",
    badgeVariant: "starter",
  },
];